import { DoctorDto } from "@apiModels/DoctorDto.csharp";
import { FormDispatch, FormFields, FormReducer } from "./formTypes";
import { LocationDto } from "@apiModels/LocationDto.csharp";

export function selectDoctorAndLocation(
  doctor: DoctorDto,
  centers: LocationDto[],
  dispatch: FormDispatch
): { doctor: DoctorDto | null; location: LocationDto | null } {
  if (!doctor) {
    console.error("Doctor not found in rootData");
    return { doctor: null, location: null };
  }

  dispatch({
    type: FormReducer.update,
    field: FormFields.doctor,
    payload: doctor,
  });

  const doctorCenters = centers.filter(
    (c) => !c.isLocation && doctor.centers.includes(c.id)
  );

  let foundLocation: LocationDto | null = null;

  if (doctorCenters.length === 1) {
    foundLocation = doctorCenters[0];
  } else {
    const locationIds = doctorCenters.map((c) => c.locationId);
    const doctorLocations = centers.filter(
      (c) => c.isLocation && locationIds.includes(c.id)
    );
    if (doctorLocations.length === 1) {
      foundLocation = doctorLocations[0];
    }
  }

  if (foundLocation) {
    dispatch({
      type: FormReducer.update,
      field: FormFields.location,
      payload: foundLocation,
    });
  }

  return { doctor, location: foundLocation };
}
